export const money = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v || 0));

export const maskCPF = (s = "") => {
  const d = String(s).replace(/\D/g, "").slice(0, 14);
  if (d.length <= 11) {
    return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return d.replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1/$2").replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

export const maskPhone = (s = "") => {
  const d = String(s).replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d{1,4})$/, "$1-$2");
  return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d{1,4})$/, "$1-$2");
};

export const statusClass = (s) => {
  if (s === "Solicitação de Reparo") return "status-badge status-solicitacao";
  if (s === "Orçamento") return "status-badge status-orcamento";
  if (s === "Aguardando Autorização") return "status-badge status-aguardando";
  if (s === "Serviço Concluído") return "status-badge status-concluido";
  return "status-badge status-pendente";
};

export const paymentClass = (s) => {
  if (s === "Pago") return "status-badge status-pago";
  if ((s || "").includes("Retirada")) return "status-badge status-orcamento";
  return "status-badge status-pendente";
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try { return new Date(iso).toLocaleString("pt-BR"); } catch { return iso; }
};
